export function ThermometerSVG({ width = 0 }: { width?: number }) {
  const percent = width + '%';
  return (
    <svg
      className='max-w-full'
      fill='none'
      height='64'
      viewBox='0 0 700 64'
      width='700'
      xmlns='http://www.w3.org/2000/svg'
    >
      <linearGradient id='gradient'>
        <stop offset='0%' stopColor='#ed255e' />
        <stop offset={percent} stopColor='#ed255e' />
        <stop offset={percent} stopColor='#E8E8EA' />
        <stop offset='100%' stopColor='#E8E8EA' />
      </linearGradient>
      <path
        d='M684 16H59.7C54.2 6.4 43.8 0 32 0C14.3 0 0 14.3 0 32C0 49.7 14.3 64 32 64C43.8 64 54.2 57.6 59.7 48H684C692.8 48 700 40.8 700 32C700 23.2 692.8 16 684 16Z'
        fill='url(#gradient)'
      />
    </svg>
  );
}
